module.exports = __webpack_public_path__ + "img/img6.2d41846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img6.jpg
// module id = 301
// module chunks = 0